import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { format } from 'date-fns'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { PTInteractiveResult, PTKldB, PTKPI, PTRun } from '../model'

export class PTAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.uploadFiles = this.uploadFiles.bind(this)
  }

  public uploadFiles(files: File[], date: Date): Promise<any> {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Content-Disposition': `form-data; name="file"`,
      },
    } as AxiosRequestConfig
    const endpoint = `/pt/upload-csv-data`
    const formData = new FormData()
    files.forEach((f) => {
      formData.append(`files`, f)
    })
    formData.append('time_of_import', `${format(date, 'yyyy-MM-dd')}`)

    return this.post(endpoint, formData, config)
      .then((response: AxiosResponse) => response)
      .catch((error) => {
        throw error
      })
  }

  public getFileUploadStatus(): Promise<{ message: string; status: boolean }> {
    const endpoint = '/pt/check-file-upload'
    return this.get<{ message: string; status: boolean }>(endpoint)
      .then((response: AxiosResponse<{ message: string; status: boolean }>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public importFile(file: File): Promise<number> {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Content-Disposition': `form-data; name="file"; filename="${file.name}"`,
      },
    } as AxiosRequestConfig
    const endpoint = `/pt/import`
    return this.put(endpoint, file, config)
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public triggerAnalysis(startValue: Date) {
    const endpoint = `pt/analyse`
    return this.post(endpoint, { time_of_import: format(startValue, 'yyyy-MM-dd') })
      .then((response: AxiosResponse) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getPtRuns(): Promise<PTRun[]> {
    const endpoint = 'pt/pt-runs'
    return this.get<PTRun[]>(endpoint)
      .then((response: AxiosResponse<PTRun[]>) =>
        response.data.map((r) => ({
          ...r,
          runAt: new Date(r.runAt),
        })),
      )
      .catch((error) => {
        throw error
      })
  }

  public getPtKPIsForCurrentRun(runId: number): Promise<PTKPI[]> {
    const endpoint = `pt/pt-kpi-results/${runId}`
    return this.get<PTKPI[]>(endpoint)
      .then((response: AxiosResponse<PTKPI[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getPtInteractiveKldbs(runId: number, q: string, type: string, language: string): Promise<PTKldB[]> {
    const endpoint = `pt/pt-interactive/${runId}`
    return this.get<PTKldB[]>(endpoint, {
      params: {
        search_query: q,
        type,
        language
      }
    })
      .then((response: AxiosResponse<PTKldB[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getPtInteractiveResults(runId: number, kldbId: number, salary: number): Promise<PTInteractiveResult[]> {
    const endpoint = `pt/pt-interactive-result/${runId}`
    return this.get<PTInteractiveResult[]>(endpoint, {
      params: {
        kldb_id: kldbId,
        salary
      }
    })
      .then((response: AxiosResponse<PTInteractiveResult[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const ptAPI = new PTAPI(httpConfig)
